// extracted by mini-css-extract-plugin
module.exports = {"box":"show-qrcode_box_ybSjO","image":"show-qrcode_image_3nTgZ","label":"show-qrcode_label_1Pv71","update":"show-qrcode_update_1-Xpc","btnGroup":"show-qrcode_btnGroup_3Ubik"};